import React from 'react';

import { ReactDirectiveProps } from '../../../ts/directives/reactDirectiveFactory';
import { ServerSettingsSubspaceName, SpaceInfo, SpaceItemForNonEntitySpace } from '../../state/SpaceInfo';
import { ConnectedSpaceInfoProvider } from '../RouterHelpers/SpaceInfoProvider';
import { ServerSettingsSpace } from './ServerSettingsSpace';

export interface ServerSettingsSpaceProviderProps extends ReactDirectiveProps {
  readonly subspaceName: ServerSettingsSubspaceName;
}

export function ServerSettingsSpaceProvider(props: ServerSettingsSpaceProviderProps) {
  const spaceInfo: SpaceInfo = {
    spaceType: 'serversettings',
    subspaceName: props.subspaceName,
    item: SpaceItemForNonEntitySpace
  };

  return (
    <ConnectedSpaceInfoProvider spaceInfo={spaceInfo}>
      <ServerSettingsSpace {...props} />
    </ConnectedSpaceInfoProvider>
  );
}
